//@ts-nocheck
import React from 'react';
import { ConfigProvider, Input } from 'antd';
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from "react-places-autocomplete";
import scriptLoader from 'react-async-script-loader';
import SearchIcon from '../../assets/Search.svg';
import CurrentLocation from '../../assets/CurrentLocation.svg';
import Pin from '../../assets/Pin.svg';
import Target from '../../assets/Target.svg';
import Add from '../../assets/Add.svg';
import Minus from '../../assets/Minus.svg';
import GoogleMapReact from 'google-map-react';
import MapPopup from './MapPopup/MapPopup';
import ReactDOMServer from "react-dom/server";
import { Error } from '../Util/Util';
import './Map.scss';

var marker: any;
const win: any = window;

interface Props {
    handleSearch: any;
    handleAddress: any;
    placeholder: string;
    rtl: boolean;
}

class Map extends React.Component<Props, any> {

    static defaultProps = {
        center: { lat: 24.7135517, lng: 46.6752957 },
        zoom: 6,
    };

    state = {
        mapApiLoaded: false,
        mapInstance: null,
        mapApi: null,
        geoCoder: null,
        places: [],
        center: this.props.center,
        zoom: this.props.zoom,
        address: "",
        draggable: true,
        lat: this.props.center.lat,
        lng: this.props.center.lng,
        iconType: '',
    }

    apiHasLoaded = (map: any, maps: any) => {
        const { center } = this.state;
        const { width } = this.props;
        const geocoder = new maps.Geocoder();
        geocoder.geocode({ location: center }, (res, status) => {
            if (status === 'OK') {
                this.setState({
                    address: res[0].formatted_address
                })
                this.props.handleAddress(res[0].formatted_address, center);
            }
        })
        this.setState({
            mapApiLoaded: true,
            mapInstance: map,
            mapApi: maps,
        });

        this.addMyLocationButton();
        map.setOptions({ disableDoubleClickZoom: true });
        if (width > 500) {
            this.customZoomInControl(map);
        } else {
            map.setOptions({ zoomControl: false, mapTypeControl: false });
        }
        this.setCurrentLocation(false);
        this.mapDoubleClickHandler(map, maps);
    };

    mapDoubleClickHandler = (map: any, maps: any) => {
        maps.event.addListener(map, 'dblclick', (e) => {
            const center = { lat: e.latLng.lat(), lng: e.latLng.lng() };

            const geocoder = new maps.Geocoder();
            geocoder.geocode({ location: center }, (res, status) => {
                if (status === 'OK') {
                    this.setState({
                        address: res[0].formatted_address
                    })

                    this.props.handleAddress(res[0].formatted_address, center);
                }
            })

            this.setState({
                lat: e.latLng.lat(),
                lng: e.latLng.lng(),
                center: center,
                iconType: 'pin'
            });
            this.setCurrentLocation(true);
        });
    }

    addMyLocationButton() {
        const { width } = this.props;
        var controlDiv = document.createElement("div");
        var firstChild = document.createElement("button");

        if (width > 500) {

            firstChild.style.marginRight = "10px";
        } else {
            firstChild.style.marginRight = "20px";
            firstChild.style.marginBottom = "20px";
        }

        firstChild.style.backgroundColor = "#008CFF";
        firstChild.style.border = "none";
        firstChild.style.outline = "none";
        firstChild.style.width = "40px";
        firstChild.style.height = "40px";
        firstChild.style.borderRadius = "2px";
        firstChild.style.boxShadow = "0 1px 4px rgba(0,0,0,0.3)";
        firstChild.style.cursor = "pointer";
        firstChild.style.padding = "0px";
        firstChild.title = "Your Location";
        controlDiv.appendChild(firstChild);

        var secondChild = document.createElement("div");
        secondChild.style.margin = "10px";
        secondChild.style.width = "18px";
        secondChild.style.height = "18px";
        secondChild.style.backgroundImage = `url(${Target})`;
        secondChild.style.backgroundSize = "18px 18px";
        secondChild.style.backgroundPosition = "0px 0px";
        secondChild.style.backgroundRepeat = "no-repeat";

        secondChild.id = "you_location_img";
        firstChild.appendChild(secondChild);
        this.state.mapInstance.controls[
            this.state.mapApi.ControlPosition.RIGHT_BOTTOM
        ].push(controlDiv);

        firstChild.addEventListener("click", () => {
            this.setCurrentLocation(false);
        });
    }

    customZoomInControl(map) {
        const { rtl } = this.props;
        // Set CSS for the control border
        var controlDiv = document.createElement("div");
        controlDiv.className = 'map-zoomcontrol'
        var controlUI = document.createElement('button');
        controlUI.style.backgroundColor = '#008CFF';
        controlUI.style.border = '2px solid #008CFF';
        controlUI.style.border = "none";
        controlUI.style.outline = "none";
        controlUI.style.width = "40px";
        controlUI.style.height = "40px";
        controlUI.style.cursor = 'pointer';
        controlUI.style.boxShadow = "0 1px 4px rgba(0,0,0,0.3)";
        controlDiv.appendChild(controlUI);

        // Set CSS for the control interior
        var controlText = document.createElement('div');
        controlText.className = 'zoom-plus';
        if (rtl) {
            controlText.style.width = "30px";
            controlText.style.backgroundPosition = "0px";
        } else {
            controlText.style.width = "25px";
            controlText.style.backgroundPosition = "5px 0px";
        }
        controlText.style.height = "18px";
        controlText.style.backgroundImage = `url(${Add})`;
        controlText.style.backgroundSize = "18px 18px";
        controlText.style.backgroundRepeat = "no-repeat";
        controlUI.appendChild(controlText);

        // Setup the click event listeners
        this.state.mapInstance.controls[
            this.state.mapApi.ControlPosition.RIGHT_BOTTOM
        ].push(controlDiv);
        controlUI.addEventListener("click", () => {
            map.setZoom(map.getZoom() + 1);
        });

        // Set CSS for the control border
        var controlUILeft = document.createElement('div');
        controlUILeft.style.backgroundColor = '#008CFF';
        controlUILeft.style.border = "none";
        controlUILeft.style.outline = "none";
        controlUILeft.style.cursor = 'pointer';
        controlUILeft.style.textAlign = 'center';
        controlUILeft.style.width = '40px';
        controlUILeft.style.height = '41px';
        controlDiv.appendChild(controlUILeft);

        // Set CSS for the control interior
        var controlTextLeft = document.createElement('div');
        controlTextLeft.className = 'zoom-minus';
        controlTextLeft.style.backgroundImage = `url(${Minus})`;
        controlTextLeft.style.width = '30px';
        controlTextLeft.style.height = '30px';
        controlTextLeft.style.backgroundSize = "18px 18px";
        if (rtl) {
            controlTextLeft.style.backgroundPosition = "0px 11px";
        } else {
            controlTextLeft.style.backgroundPosition = "11px 11px";
        }
        controlTextLeft.style.backgroundRepeat = "no-repeat";
        controlTextLeft.style.borderRadiusBottomRight = "4px";
        controlTextLeft.style.borderRadiusBottomLeft = "4px";
        controlUILeft.appendChild(controlTextLeft);

        // Setup the click event listeners
        controlUILeft.addEventListener("click", () => {
            map.setZoom(map.getZoom() - 1);
        });
    }

    setCurrentLocation(isCordProvided: Boolean) {
        const { mapApi, center } = this.state;
        const { dispatch, } = this.props;

        navigator.geolocation.getCurrentPosition(position => {
            if (position.coords.latitude !== null && position.coords.longitude !== null && mapApi !== null) {
                if (!isCordProvided) {
                    this.setState({
                        lat: position.coords.latitude,
                        lng: position.coords.longitude,
                    });
                }

                const geocoder = new mapApi.Geocoder();
                geocoder.geocode({
                    location: {
                        lat: parseFloat(this.state.lat),
                        lng: parseFloat(this.state.lng),
                    }
                }, (results: any, status: any) => {
                    const myLatlng = {
                        lat: this.state.lat,
                        lng: this.state.lng,
                    };

                    this.setState({
                        center: myLatlng
                    })

                    this.userLocationMarkerSet(isCordProvided, myLatlng);

                    if (status === "OK") {
                        if (results[0]) {
                            this.handleAddressChange(results[0].formatted_address, myLatlng);
                            this.props.handleAddress(results[0].formatted_address, myLatlng);
                            this.props.dispatch({ type: 'SET_LOADER', payload: false })
                        }
                    } else {
                        console.log("Geocoder failed due to: " + status);
                        this.props.dispatch({ type: 'SET_LOADER', payload: false })
                    }
                });
            }
        }, (error) => {
            this.userLocationMarkerSet(isCordProvided, center);
            dispatch({ type: 'SET_LOADER', payload: false })
        });
    }

    handleAddressChange = (value: any, ltLg: any) => {
        this.setState({
            address: value
        })
    }

    handleSelect = async (value: any) => {
        const results = await geocodeByAddress(value);
        const latLng = await getLatLng(results[0]);

        this.handleAddressChange(value, latLng);
        this.setState({
            center: {
                lat: latLng.lat,
                lng: latLng.lng,
            },
            lat: latLng.lat,
            lng: latLng.lng,
            address: value,
            iconType: 'entered'
        });
        this.state.mapInstance.setZoom(18);
        this.props.handleAddress(value, latLng);
        this.setCurrentLocation(true);
    }

    onSearchClick = () => {
        if (this.state.address.length > 0) {
            this.props.handleSearch(true, this.state.center);
            this.setCurrentLocation(true);
        }
    }

    userLocationMarkerSet = (isCordProvided, myLatlng: any) => {
        const { mapApi, iconType } = this.state;
        const { handleSearch, t } = this.props;

        if (this.state.mapInstance) {
            this.state.mapInstance.setCenter(myLatlng);
            this.state.mapInstance.setZoom(16);
            if (marker) {
                marker.setMap(null);
            }

            marker = new this.state.mapApi.Marker({
                position: myLatlng,
                icon: !isCordProvided ? CurrentLocation : Pin
            });

            const infowindow = new this.state.mapApi.InfoWindow({
                content: '',
                width: 200,
            });

            marker.addListener("click", () => {
                const mapPopup = ReactDOMServer.renderToString(
                    <MapPopup title={!isCordProvided ? t('CurrentLocation') : iconType === 'pin' ? t('Pin_address') : t('Entered_address')} places={this.state.address} visitingFrom={'Map'} buttonText={t('Check_coverage')} />
                );
                infowindow.setContent(mapPopup);
                infowindow.open({
                    anchor: marker,
                    map: mapApi,
                    shouldFocus: false,
                });
            });

            mapApi.event.addListener(infowindow, "domready", function () {
                const btn = document.getElementById('mpuButton');
                btn?.addEventListener('click', function () {
                    handleSearch(true, myLatlng);
                })
            })

            marker.setMap(this.state.mapInstance);
        }
    }


    render() {
        const { rtl, placeholder, mapValue, isScriptLoaded, isScriptLoadSucceed } = this.props;
        const defaultMapOptions = {
            fullscreenControl: false,
        };

        if (isScriptLoaded && isScriptLoadSucceed) {
            return (
                <>
                    <div className='map__container'>
                        <PlacesAutocomplete
                            value={this.state.address}
                            onSelect={this.handleSelect}
                            onChange={this.handleAddressChange}
                            searchOptions={{ componentRestrictions: { country: ["sa"] } }}
                        >
                            {({
                                getInputProps,
                                suggestions,
                                getSuggestionItemProps,
                                loading,
                            }) => (
                                <>
                                    <ConfigProvider direction={rtl ? "rtl" : "ltr"}>
                                        <div className='map__inputField' style={rtl ? { float: 'right', right: '40px' } : { float: 'left', left: '40px' }}>
                                            <div className='inputSection__withIcon' style={{ direction: rtl ? 'rtl' : 'ltr' }}>
                                                <Input
                                                    className={rtl ? 'input-section mapInput-right' : 'input-section mapInput-left'}
                                                    value={mapValue}
                                                    {...getInputProps({
                                                        placeholder: placeholder,
                                                    })}
                                                />
                                                <img src={SearchIcon} alt='icon' onClick={this.onSearchClick} style={rtl ? { left: '35px' } : { right: '30px' }} />
                                            </div>
                                        </div>
                                    </ConfigProvider>
                                    <div className='map__suggestion' style={rtl ? { right: '42px' } : { left: '42px' }}>
                                        {loading && <div>Loading...</div>}
                                        {suggestions.map((suggestion, index) => {

                                            const style = {
                                                backgroundColor: suggestion.active ? "#C3CED0" : "#fff",
                                                cursor: 'pointer',
                                                display: loading ? 'none' : 'block',
                                                padding: '5px 24px'
                                            };

                                            return (
                                                <div key={index} {...getSuggestionItemProps(suggestion, { style })}>
                                                    {suggestion.description}
                                                </div>
                                            );
                                        })}
                                    </div>
                                </>
                            )}
                        </PlacesAutocomplete>
                        <GoogleMapReact
                            center={this.state.center}
                            zoom={this.state.zoom}
                            draggable={this.state.draggable}
                            options={defaultMapOptions}
                            bootstrapURLKeys={{
                                key: win['googleMapKey'],
                                libraries: ["places", "geometry"],
                            }}
                            yesIWantToUseGoogleMapApiInternals
                            onGoogleApiLoaded={({ map, maps }) =>
                                this.apiHasLoaded(map, maps)
                            }

                        >
                        </GoogleMapReact>
                    </div>
                </>
            )
        } else {
            return <></>
        }
    }
}

export default scriptLoader(`https://maps.googleapis.com/maps/api/js?key=${win['googleMapKey']}&libraries=places&language=${win["lang"]}&region=${win["lang"]}`)(Map);